if (!global._babelPolyfill) require("babel-polyfill");
import React from "react";
import { withNamespaces } from "react-i18next";
import Cookies from "js-cookie";
import Suggestions from "./Suggestions";
import SearchInput from "./SearchInput";

class SearchBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      query: props.address || props.query || "",
      queryResults: [],
      cursorIdx: 0,
      getMouseInSuggestions: false,
      inputFocused: false,
      onlyAddress: props.onlyAddress || false,
    };
    this.searchInputRef = React.createRef();
  }

  handleInputChange = (event) => {
    this.search(event.target.value);
  };

  search = (query) => {
    this.setState({ query });
    this.sendQuery(query);
    if (this.props.valueCallback) {
      this.props.valueCallback(query);
    }
  }

  showResults = () => {
    const { query, queryResults, inputFocused } = this.state;
    return query && query.length > 0 && queryResults && queryResults.length > 0 && inputFocused;
  };

  async sendQuery(query) {
    const { country, onlyAddress } = this.props;
    try {
      const queryResults = await getResults(
        query,
        country,
        onlyAddress
      );
      if (queryResults.error) throw queryResults.error;
      if (onlyAddress) {
        const queryFeatures = queryResults.response.addresses;
        const filteredFeatures = queryFeatures.filter((item) => item.formattedAddress);
        this.setState({ queryResults: filteredFeatures });
      } else {
        this.setState({ queryResults: queryResults.response.addresses });
      }
    } catch (e) {
      if (!(e instanceof DOMException && e.name == "AbortError")) {
        console.error("Error connecting to Radar API, check internet / api token");
      }
    }
  }

  handleClick = ({ event, location }) => {
    const { onlyAddress } = this.state;
    this.setState({
      query: onlyAddress
        ? location.addressLabel
          ? location.formattedAddress.split(",")[0].slice(0)
          : ""
        : location.formattedAddress,
      cursorIdx: 0,
      getMouseInSuggestions: false,
    }, () => {
      this.updateCityAndStateFields(location);
      const addressInput = document.getElementById('address-input');
      if (addressInput) {
        const changeEvent = new Event('change', { bubbles: true });
        addressInput.dispatchEvent(changeEvent);
      }
    });
    if (this.props.callback) {
      this.props.callback({ location, event });
    }
  };

  updateCityAndStateFields = (location) => {
    const cityInput = document.getElementById('city');
    const stateInput = document.getElementById('state');

    if (cityInput && location.addressLabel && location.formattedAddress) {
      const addressParts = location.formattedAddress.split(',');
      if (addressParts.length >= 2) {
        const cityValue = addressParts.length === 2 ? addressParts[0].trim() : addressParts[1].trim();
        cityInput.value = cityValue;
      }
    }

    if (stateInput && location.stateCode) {
      stateInput.value = location.stateCode;
    }
  };

  handleArrowKeys = (event) => {
    if (this.state.getMouseInSuggestions) {
      return;
    }

    const keyIsLetter = event.keyCode >= 65 && event.keyCode <= 90;
    const keyIsBackspace = event.keyCode == 8;
    if ((keyIsLetter || keyIsBackspace) && this.state.cursorIdx !== 0) {
      this.setState({ cursorIdx: 0 });
    }
    const { queryResults, cursorIdx } = this.state;
    switch (event.keyCode) {
      case 38: {
        // up arrow pressed
        event.preventDefault();
        if (this.showResults() && cursorIdx > 0)
          this.setState((prevState) => ({
            cursorIdx: prevState.cursorIdx - 1,
          }));
        break;
      }
      case 40: {
        // down arrow pressed
        event.preventDefault();
        if (this.showResults() && cursorIdx < queryResults.length - 1)
          this.setState((prevState) => ({
            cursorIdx: prevState.cursorIdx + 1,
          }));
        break;
      }

      case 13: {
        // enter pressed
        event.preventDefault();
        if (this.showResults()) {
          document.activeElement.blur();
          this.handleClick({
            location: queryResults[cursorIdx],
          });
        }
        break;
      }
    }
  };

  getMouseInSuggestions = (bool) => {
    const { cursorIdx } = this.state;

    this.setState((prevState) => {
      return {
        getMouseInSuggestions:
          prevState.getMouseInSuggestions !== bool
            ? bool
            : prevState.getMouseInSuggestions,
        cursorIdx: bool && cursorIdx !== 0 ? 0 : prevState.cursorIdx,
      };
    });
  };

  handleFocus = () => {
    this.setState({ inputFocused: true });
  };

  handleBlur = () => {
    this.setState({ inputFocused: false });
  };

  render() {
    const {
      queryResults,
      query,
      cursorIdx,
      getMouseInSuggestions,
      onlyAddress
    } = this.state;
    const { t, searchHint, inputName } = this.props;
    return (
      <React.Fragment>
        <div
          className="searchBoxWrapper"
          onMouseLeave={!isTouch ? this.handleMouseLeave : undefined}
          onKeyDown={!isTouch ? this.handleArrowKeys : undefined}
          onMouseEnter={!isTouch ? this.handleMouseEnter : undefined}
        >
          <SearchInput
            className={this.props.className || "js-required-if-visible form-control string optional form__input form__input--black-border type--c3"}
            hasResults={this.showResults()}
            value={ query }
            handleFocus={this.handleFocus}
            handleBlur={this.handleBlur}
            searchHint={searchHint || "Search"}
            handleInputChange={this.handleInputChange}
            onlyAddress={onlyAddress}
            inputName={inputName}
            inputRef={this.searchInputRef}
          />
          <Suggestions
            places={queryResults}
            selectColor={this.props.selectColor || "#58a"}
            hasResults={this.showResults()}
            clickHandler={this.handleClick}
            isTouch={isTouch}
            cursorIdx={cursorIdx}
            mouseInSuggestions={getMouseInSuggestions}
            getMouseInSuggestions={this.getMouseInSuggestions}
          />
        </div>
      </React.Fragment>
    );
  }
}

const isTouch = "ontouchstart" in window || navigator.msMaxTouchPoints > 0;

const buildQuery = (
  query,
  country,
  onlyAddress
) => {
  const base_url = "https://api.radar.io/v1/search/autocomplete";
  let endpoint = `${base_url}?query=${query}&limit=5&access_token=${getMapProviderApiKey()}`;
  if (country) {
    endpoint += `&countryCode=${country}`;
  }
  if (Cookies.get("long") && Cookies.get("lat")) {
    endpoint += `&near=${Cookies.get("lat")},${Cookies.get("long")}`
  }
  endpoint += `&layers=address${onlyAddress ? '' : ',coarse'}`;
  return endpoint;
};

let abortController
const cancelOngoingRequest = () => {
  if (abortController) {
    abortController.abort();
  }
  abortController = new AbortController();
}

const getMapProviderApiKey = () => {
  return 'prj_live_pk_bb7c2df77ea0057c42087ad1dc5b930c66c427a9';
}

const getResults = async (query, country) => {
  if (query === "") {
    return {
      response: {
        features: [],
      },
    };
  }

  try {
    cancelOngoingRequest();
    const path = buildQuery(query, country);
    const response = await fetch(path, {
      signal: abortController.signal,
      headers: {
        "Content-Type": "application/json",
        'Authorization': getMapProviderApiKey()
      },
    });

    if (!response.ok) {
      throw Error(response.statusText);
    }

    const queryResults = await response.json();
    return {
      response: queryResults,
    };
  } catch (error) {
    return {
      error,
    };
  }
};

export default withNamespaces()(SearchBox);
